import { api } from '@/lib/api'
import type { CreatePrepaidPayload, PrepaidDetailResponse, PrepaidSchedule } from './types'

export const prepaidApi = {
  list: () => api.get<PrepaidSchedule[]>('/api/schedules/prepaid'),
  detail: (id: number) => api.get<PrepaidDetailResponse>(`/api/schedules/prepaid/${id}`),
  create: (body: CreatePrepaidPayload) =>
    api.post<{ id?: number; message?: string }>('/api/schedules/', body),
  update: (id: number, body: Partial<CreatePrepaidPayload>) =>
    api.put<{ id?: number; message?: string }>(`/api/schedules/${id}`, body),
  remove: (id: number) => api.del<{ message?: string }>(`/api/schedules/${id}`),
}
